import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useController } from "react-hook-form";
import { Fieldset } from "ui-components/Form";
import { Text } from "ui-components/Form";

function RecvSerialNumber({ data, append, remove, control, errors, serialNumbers, quantity, alert, setValue }) {
  return (
    <Fieldset label="Serial Number">
      {alert}
      <MDButton
        variant="gradient"
        color="info"
        sx={{ width: "fit-content" }}
        onClick={() => append({ serialNumber: "", newItem: true, active: true })}
        disabled={serialNumbers.some((x) => !Boolean(x.serialNumber)) || serialNumbers.length >= quantity}
      >
        add&nbsp;serial&nbsp;number
      </MDButton>
      <MDBox mt={1.625} sx={{ maxHeight: "15rem", overflow: "scroll" }}>
        {data.map(
          (x, index) =>
            index % 2 === 0 && (
              <Grid container spacing={3} key={index}>
                <Grid item xs={4}>
                  <Text
                    key={x.id}
                    field={{
                      type: "text",
                      label: "",
                      name: `serialNumbers.${index}.serialNumber`,
                      control,
                      errors,
                      onChange: (e) => {
                        setValue(`serialNumbers.${index}.serialNumber`, e.target.value, {
                          shouldValidate: true,
                          shouldDirty: true,
                        });
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <MDButton variant="gradient" color="info" onClick={() => remove(index)}>
                    Delete
                  </MDButton>
                </Grid>
                {data[index + 1] && (
                  <>
                    <Grid item xs={4}>
                      <Text
                        key={data[index + 1].id}
                        field={{
                          type: "text",
                          label: "",
                          name: `serialNumbers.${index + 1}.serialNumber`,
                          control,
                          errors,
                          onChange: (e) => {
                            setValue(`serialNumbers.${index + 1}.serialNumber`, e.target.value, {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <MDButton variant="gradient" color="info" onClick={() => remove(index + 1)}>
                        Delete
                      </MDButton>
                    </Grid>
                  </>
                )}
              </Grid>
            )
        )}
      </MDBox>
    </Fieldset>
  );
}

export default RecvSerialNumber;
